export default __webpack_public_path__ + "static/circle_b.06cdf1baef9674b13d700345732af7a8.svg";